<script setup lang="ts">
import { useId } from 'vue'

interface Option {
  label: string
  value: any
}

const props = defineProps<{
  modelValue: any
  options: (string | Option)[]
  label: string
  placeholder?: string
}>()

// Lets the browser identify the field (autofill, DevTools form checks); stable across SSR and hydration.
const selectId = useId()

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const normalizedOptions = computed(() => {
  return props.options.map(opt => {
    if (typeof opt === 'object' && opt !== null && 'label' in opt) {
      return opt as Option
    }
    return { label: String(opt), value: opt }
  })
})
</script>

<template>
  <div class="w-full max-w-sm lg:hidden relative">
    <div class="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none text-oxo-red">
      <i class="fas fa-chevron-down" aria-hidden="true"></i>
    </div>
    <select
      :id="selectId"
      :value="modelValue"
      @change="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
      class="w-full appearance-none bg-neutral-900 border border-oxo-border text-white text-sm font-bold uppercase tracking-wider rounded-xl px-6 py-4 outline-hidden focus:border-oxo-red transition-all cursor-pointer"
      :aria-label="label"
    >
      <option v-if="placeholder" :value="undefined" disabled>{{ placeholder }}</option>
      <option 
        v-for="(option, idx) in normalizedOptions" 
        :key="idx" 
        :value="option.value"
        class="bg-neutral-900 text-white py-2"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
